import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import Cookies from 'vue-cookies'
import { getLanguage } from '@/lang/index'
import { isNotNeedLoginPage } from '@/lib/business'
const context = require.context('./modules', false, /\.js$/)
// 获取moudules文件下所有js文件；
const moduleStores = {}
context.keys().forEach((key) => {
  // context.keys()    返回匹配成功模块的名字组成的数组
  const fileName = key.slice(2, -3)
  const fileModule = context(key).default
  // 通过 context(key)导出文件内容。在文件中时通过 export.default 导出的，所以后边加.default
  moduleStores[fileName] = {
    ...fileModule,
    namespaced: true // 文件中有写可以省略；不过这样写可以不用给每个文件写入；这个属性不知道自己去查文档；
  }
})

Vue.use(Vuex)
const lang = getLanguage()
const store = new Vuex.Store({
  state: {
    logoAndBack: {}, // 背景图片和logo
    userInfo: {}, // 用户登录信息
    unread: '',
    routeQuery: {},
    language: lang,
    isEnglish: true,
    webConfig: {
      appIndexStyle: '',
      back: '',
      backClient: '',
      bonusAmount: '',
      clientUiStyle: '2',
      darkLogo: '',
      demoAccountAllowed: '',
      email: true,
      icon: '',
      iconOrButtonColor: '',
      invitationRequire: '',
      lgoinUrl: '',
      loginFramePosition: '',
      loginMethod: [],
      loginStyle: '',
      loginWay: [],
      logo: '',
      name: '',
      nameLimitSwitch: '',
      newRegistrationBonus: '',
      npsStatus: '',
      onlineServiceCode: '',
      onlineServicePosition: '',
      onlineServiceStatus: '',
      phone: true,
      registVerificationMode: '',
      registerAgent: '',
      remindCreateAccount: '',
      secretKey: '',
      skipAddress: '',
      sliderVerification: '',
      userRegister: '',
      userRegisterNameFormat: '',
      usernameLangues: '',
      usernameModifyAllowed: '',
      webMenuPosition: 1, // 1-菜单在左侧 2-菜单在顶部
      webIndexStyle: 1 // 1-旧版首页 2-新版首页
    },
    availableRoutes: [],
    realSetting: undefined,
    hasRealVerify: undefined,
    demoSetting: undefined,
    unpaidCount: 0,
    countUnRead: 0,
    tagsSetting: 0,
    guide: {
      openAccountData: undefined
    },
    userSetting: false,
    resizeList: [],
    defaultAreaCode: {
      zh: '+86',
      tc: '+852',
      en: '+1',
      ja: '+81',
      ko: '+82',
      th: '+66',
      vi: '+84',
      id: '+62',
      ar: '+971',
      es: '+34'
    },
    firstNewLogin: false,
    userColumnInfo: [],
    investdetail: {},
    productdetail: {},
    Ertragsabrechnungsmethode: null,
    redeem: {}, // 赎回需要的数据
    npsList: [], // nps
    menuList: [], // 左侧菜单列表
    languageList: [], // 多语言
    quickEntrancesTop4: [], // 快捷入口
    quickEntrances: [],
    themeMode: localStorage.getItem('theme-mode'), // 当前主题模式
    $device: {
      mobile: false
    },
    pammSetting: {
      id: 1,
      viewStopped: 0,
      viewSubAccount: 1,
      viewProjectRecord: 1,
      viewProfitTrend: 1,
      viewBuyCount: 1,
      viewTradeOrder: 1,
      viewPositionOrder: 1,
      viewProfitList: 1,
      viewRateSuccess: 1,
      viewMaxRetreat: 1,
      enableCreateProduct: 0,
      yieldCurveColor: 1,
      yieldCurveCycle: 2,
      productListOrderBy: 2,
      productListSort: 2,
      productListOrderSql: 'profit_rate desc'
    },
    kycAuthInfo: null,
    notices: [],
    hasdealpwd: false, // 是否设置了资金密码
    walletsList: [],
    RealaccountList: [],
    serverAllowed: {
      bindAllowed: '0',
      demoAccountAllowed: '0',
      realAccountAllowed: '0'
    },
    demoAccountList: [],
    tempLang: false,
    internalTransferSetting: null,
    spreadPageSetting: null,
    accountType: 1,
    summaryInfo: {
      summary: 0,
      netWorthTotal: 0,
      creditAmountTotal: 0
    }
  },
  mutations: {
    setAccountType(state, payload) {
      state.accountType = payload
    },
    setnpsList(state, payload) {
      // 设置nps
      state.npsList = payload
    },
    setOpenAccountData(state, payload) {
      state.guide.openAccountData = payload
    },
    setWebConfig(state, payload) {
      payload.webMenuPosition = Number(payload.webMenuPosition)
      payload.webIndexStyle = Number(payload.webIndexStyle)
      // payload.webMenuPosition = 2
      // payload.webIndexStyle = 2
      state.webConfig = payload
    },
    setPermissions(state, payload) {
      state.availableRoutes = (payload?.userMenu ?? []).map((item) => {
        if (item.indexOf('?type=') !== -1) {
          // eslint-disable-next-line no-param-reassign
          item = item.split('?type=').join(':')
        }
        return item
      })
      state.realSetting = payload?.realSetting
      state.hasRealVerify = payload?.hasRealVerify
      state.demoSetting = payload?.demoSetting
      state.unpaidCount = payload?.unpaidCount ?? 0
      state.userSetting = payload?.userSetting ?? false
    },
    setMenusList(state, menuList) {
      state.menuList = menuList
    },
    setWinResize(state, fn) {
      state.resizeList.push(fn)
    },
    setUnpaidCount(state, payload) {
      state.unpaidCount = payload ?? 0
    },
    setcountUnRead(state, payload) {
      state.countUnRead = payload ?? 0
    },
    settagsSetting(state, payload) {
      state.tagsSetting = payload ?? 0
    },
    // 存储是否有英文限制
    set_isEnglish(state, isEnglish) {
      state.isEnglish = isEnglish
      sessionStorage.isEnglish = isEnglish
    },
    // 存储背景和logo
    set_logoBack(state, logoBack) {
      const keys = Object.keys(logoBack)
      keys.forEach((k) => {
        state.logoAndBack[k] = logoBack[k]
      })
      state.logoAndBack = cloneDeep(state.logoAndBack)
      sessionStorage.logoAndBack = state.logoAndBack
    },
    // 保存登录后用户信息
    set_userInfo(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
      // const lang = state.languageList.find((it) => it.code === state.userInfo.preferenceLanguage)
      // if (lang) {
      //   if (String(lang.value) === String(state.language)) {
      //     return
      //   }
      //   i18n.locale = lang.value
      //   Cookies.set('language', lang.value)
      //   sessionStorage.setItem('language', lang.value)
      // }
    },
    setTest(state, userInfo) {
      state.userInfo.boundGoogle = userInfo.boundGoogle
    },
    // 用户清除登录后保存的信息
    del_userInfo(state) {
      state.userInfo = ''
      localStorage.removeItem('userInfo')
    },
    // 存储未读消息条数
    set_unread(state, unread) {
      state.unread = unread
      sessionStorage.unread = unread
    },
    setNotices(state, notices) {
      state.notices = notices
    },
    set_routeQuery(state, routeQuery) {
      state.routeQuery = routeQuery
      sessionStorage.routeQuery = routeQuery
    },
    set_investdetail(state, param) {
      state.investdetail = param
    },
    set_productdetail(state, param) {
      state.productdetail = param
    },
    // 设置收益结算方式
    set_Ertragsabrechnungsmethode(state, number) {
      state.Ertragsabrechnungsmethode = number
    },
    set_redeem(state, param) {
      state.redeem = param
    },
    setLanguageList(state, languageList) {
      state.languageList = languageList
    },
    setquickEntrancesconfig(state, { quickEntrancesTop4, quickEntrances, spreadPageSetting, internalTransferSetting }) {
      state.quickEntrancesTop4 = quickEntrancesTop4
      state.quickEntrances = quickEntrances
      state.internalTransferSetting = internalTransferSetting
      state.spreadPageSetting = spreadPageSetting
    },
    setThemeMode(state, mode) {
      state.themeMode = mode
    },
    setKycAuthInfo(state, authInfo) {
      state.kycAuthInfo = authInfo
    },
    setDevice(state, $device) {
      state.$device = $device
    },
    setFirstNewLogin(state, firstNewLogin) {
      state.firstNewLogin = firstNewLogin
    },
    setUserColumnInfo(state, userColumnInfo) {
      state.userColumnInfo = userColumnInfo
    },
    setPammSetting(state, setting) {
      state.pammSetting = setting
    },
    setHasDealPwd(state, hasdealpwd) {
      state.hasdealpwd = hasdealpwd
    },
    setWalletsList(state, walletsList) {
      state.walletsList = walletsList
    },
    setRealaccountList(state, RealaccountList) {
      state.RealaccountList = RealaccountList
    },
    setDemoAccountList(state, accounts) {
      state.demoAccountList = accounts
    },
    setHeadImg(state, headImg) {
      state.userInfo.headImg = headImg
    },
    setServerAllowed(state, serverAllowed) {
      state.serverAllowed = serverAllowed
    },
    // 未登录时用户切换语言
    setTempLang(state, lang) {
      state.tempLang = lang
      Cookies.set('language', lang)
      sessionStorage.setItem('language', lang)
    },
    setSummaryInfo(state, summaryInfo) {
      state.summaryInfo.summary = summaryInfo.summary || 0
      state.summaryInfo.netWorthTotal = summaryInfo.netWorthTotal || 0
      state.summaryInfo.creditAmountTotal = summaryInfo.creditAmountTotal || 0
    }
  },
  getters: {
    availablePages(state) {
      return state.availableRoutes
    },
    webConfig: (state) => state.webConfig,
    fundKey: () => localStorage.getItem('fundKey'),
    isNotCompletedKYCStatus(state) {
      return !state.userColumnInfo.every((item) => item.status === 1)
    },
    colorPreference: (state) => {
      if (state.userInfo.colorPreference !== '') {
        return state.userInfo.colorPreference
      }
      return state.webConfig.colorPreference
    },
    language(state) {
      if (isNotNeedLoginPage()) {
        if (state.tempLang) {
          return state.tempLang
        } else if (Cookies.get('language')) {
          return Cookies.get('language')
        } else {
          return navigator.language
        }
      } else {
        const lang = state.languageList.find((it) => it.code === state.userInfo.preferenceLanguage)
        if (lang) {
          return lang.value
        } else if (Cookies.get('language')) {
          return Cookies.get('language')
        } else if (state.languageList.length) {
          return state.languageList[0].value
        }
      }
      return ''
    },
    langText(state) {
      if (state.userInfo.preferenceLanguage) {
        const lang = state.languageList.find((it) => it.code === state.userInfo.preferenceLanguage)
        if (lang) {
          return lang.name
        }
      }
      if (Cookies.get('language')) {
        const lang = state.languageList.find((it) => it.code === Cookies.get('language'))
        if (lang) {
          return lang.name
        }
      }
      if (state.languageList.length) {
        return state.languageList[0].name
      }
      return ''
    }
  },
  modules: moduleStores
})

export default store
